(function () {
  class ReelSpinnerVisualSCS extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      dynamicSpinner,
      nudgeReel
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp,
        dynamicSpinner,
        nudgeReel
      );

      this._reelId = parseInt(reelId.replace('reel', ''));

      this._cashOverlays = [];
      this._multiplierOverlays = [];
      this._fishDataOnReel = [];
    }

    createCashOverlays() {
      let totalAppertureSize = this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];
        let overlayText = resourceManager.createObject(
          'text',
          `cashOverlay:reel${this._reelId}:row${i}`,
          gfxObject.symbol.childContainer,
          {
            text: '???',
            fontDefinition: 'cashFish',
            maxWidth: 140,
            anchor: 0.5,
            x: 0,
            y: 55,
          }
        );
        let overlayTextGrey = resourceManager.createObject(
          'text',
          `cashOverlayGrey:reel${this._reelId}:row${i}`,
          gfxObject.symbol.childContainer,
          {
            text: '???',
            fontDefinition: 'cashFishGrey',
            maxWidth: 140,
            anchor: 0.5,
            x: 0,
            y: 60,
          }
        );
        overlayText.visible = false;
        overlayTextGrey.visible = false;
        let overlayTexts = {
          normal: overlayText,
          grey: overlayTextGrey,
        };
        this._cashOverlays.push(overlayTexts);
      }
    }

    createMultiplierOverlays() {
      let totalAppertureSize = this.getReelSpinnerData().getTotalAppertureSize();

      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let overlay = resourceManager.createObject('movie', 'multiplierOverlay', gfxObject.symbol.childContainer, {
          definition: 'multipliers',
          anchor: 0.5,
          x: 0,
          y: 50,
          scale: 1,
          loop: false,
        });

        overlay.visible = false;
        this._multiplierOverlays.push(overlay);
      }
    }

    startDynamicSpin() {
      super.startDynamicSpin();
      this._fishDataOnReel = [];
    }

    updateSymbolOverlays(ids, overlays) {
      // if (gameController.gameAborted) {
      //   return;
      // }
      super.updateSymbolOverlays(ids, overlays);

      // Add overlay data here
      for (let i = 0; i < ids.length; i++) {
        let symId = ids[i];
        let overlay = overlays[i];

        // Sym 9 for fish that won't land but will spin past
        if (symId === 9) {
          if (overlay.cashFishValue === undefined) {
            const startingData = gameController.getStartingCashPotOverrideData(this._reelId, i);
            let passingFish;

            if (startingData && gameController.displayingStartingSymbols) {
              // Use fixed data for starting symbols display
              passingFish = startingData;
            } else {
              // Use random data for spinning symbols
              passingFish = gameController.getFishSpinningPastData();
            }

            let symbolData = this._reelSpinnerData.getSymbolData();
            symbolData[i].symId = passingFish.symbolId;
            overlay.cashFishValue = passingFish.value;
          }
        }
        // Sym 18-23 for fish that will land
        if (symId >= 18 && symId <= 23) {
          // Need to check cashFishValue is undefined so it doesn't confuse land symbols
          // with the spinning past symbols setup above
          if (overlay.cashFishValue === undefined) {
            if (this._fishDataOnReel.length === 0) {
              let fishData = gameController.getFishData();
              if (fishData) {
                for (let fish = 0; fish < fishData.length; fish++) {
                  if (fishData[fish].coord.reel === this._reelId) {
                    this._fishDataOnReel.push(fishData[fish]);
                  }
                }
              }
              //We sort the fish by reverse row order so we know the order to place them
              if (this._fishDataOnReel.length > 0) {
                this._fishDataOnReel.sort((a, b) => b.coord.row - a.coord.row);
              }
            }
            if (this._fishDataOnReel.length > 0) {
              let curFish = this._fishDataOnReel.shift();
              let baseVal = curFish.amount;
              overlay.cashFishValue = baseVal;
            }
          }
        }
      }

      // Display overlay data here if available
      for (let i = 0; i < ids.length; i++) {
        let overlay = overlays[i];

        if (overlay.cashFishValue === undefined) {
          this._cashOverlays[i].normal.visible = false;
          this._cashOverlays[i].grey.visible = false;
        } else {
          let amount = gdk.formatCurrency(overlay.cashFishValue);

          if (ids[i] >= 18 && ids[i] <= 23) {
            this._cashOverlays[i].normal.visible = false;
            this._cashOverlays[i].grey.visible = true;
            this._cashOverlays[i].grey.setText(amount);
          }
        }
      }

      // Wild Multiplier Overlays
      for (let i = 0; i < ids.length; i++) {
        this._multiplierOverlays[i].visible = false;

        let symId = ids[i];

        if (symId === 11) {
          this._multiplierOverlays[i].gotoAndStop(0);
          this._multiplierOverlays[i].visible = true;
        } else if (symId === 12) {
          this._multiplierOverlays[i].gotoAndStop(1);
          this._multiplierOverlays[i].visible = true;
        } else if (symId === 13) {
          this._multiplierOverlays[i].gotoAndStop(2);
          this._multiplierOverlays[i].visible = true;
        } else if (symId === 14) {
          this._multiplierOverlays[i].gotoAndStop(3);
          this._multiplierOverlays[i].visible = true;
        }
      }
    }

    dimSymbol(row, showDim, duration) {
      super.dimSymbol(row, showDim, duration);

      const multiplierOverlay = this._multiplierOverlays[row];

      if (showDim) {
        //const normalCashFish = this._cashOverlays[row].normal;
        //const greyCashFish = this._cashOverlays[row].grey;

        //normalCashFish.alpha = 0.2;
        //greyCashFish.alpha = 0.2;
        multiplierOverlay.tint = 0x555555;
      } else {
        multiplierOverlay.tint = 0xffffff;
      }
    }

    clearDimSymbolIds(duration) {
      super.clearDimSymbolIds(duration);

      for (let i = 0; i < this._cashOverlays.length; ++i) {
        this._cashOverlays[i].normal.scale.set(1.0);
        this._cashOverlays[i].grey.scale.set(1.0);
        this._multiplierOverlays[i].tint = 0xffffff;
      }
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 2;
    return new ReelSpinnerVisualSCS(
      json.ID,
      json.ID + ' container',
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp,
      gameController.dynamicSpinner,
      json.nudgeReel
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
    reelSpinnerVisual.createCashOverlays();
    reelSpinnerVisual.createMultiplierOverlays();
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType('ReelSpinnerVisualSCS', create, initialise, getRequiredFiles);
})();
